// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_3HnF4","background":"-dVKr","header":"_3LM7v","action":"jXK2l","iframeWrapper":"_2pFzR"};